import React from 'react';
import { Loader2 } from 'lucide-react';

const BASE = 'inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed';
const VARIANTES = {
  primario: 'bg-green-700 text-white hover:bg-green-800',
  secundario: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
  peligro: 'border border-red-300 bg-white text-red-700 hover:bg-red-50',
  icono: 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
};
const TAMANOS = {
  normal: 'min-h-[36px] px-3 py-1.5 text-sm',
  // En pantallas tactiles el objetivo crece a 44px.
  icono: 'h-9 w-9 [@media(pointer:coarse)]:h-11 [@media(pointer:coarse)]:w-11'
};

// Boton unico de Chats. Los solo-icono exigen "etiqueta" (aria-label y tooltip).
const Boton = ({ variante = 'secundario', icono: Icono, etiqueta, cargando = false, disabled, children, className = '', ...resto }) => {
  const soloIcono = variante === 'icono';
  const Visible = cargando ? Loader2 : Icono;
  return (
    <button
      type="button"
      title={etiqueta}
      aria-label={soloIcono ? etiqueta : undefined}
      aria-busy={cargando || undefined}
      disabled={disabled || cargando}
      className={`${BASE} ${VARIANTES[variante]} ${soloIcono ? TAMANOS.icono : TAMANOS.normal} ${className}`}
      {...resto}
    >
      {Visible && <Visible size={soloIcono ? 18 : 15} className={cargando ? 'animate-spin' : ''} aria-hidden="true" />}
      {children}
    </button>
  );
};

export default Boton;
